import axios from "axios";
import { showSessionExpiredModal } from "../slices/authSlice";
import getTenantId from "../../components/Tenent";

const getStore = () => require("../store").store;

// Requests that already surface their own inline error UI — a 401 from these
// shouldn't also pop the global "session expired" modal.
const SILENT_401_URLS = [
  "/core/user/login",
  "/core/user/mfa/setup",
  "/core/user/mfa/verify-setup",
  "/core/user/login/mfa",
];

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_API}`,
  withCredentials: true,
  headers: { accept: "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["x-tenant-id"] = getTenantId();
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (
      err.response?.status === 401 &&
      !SILENT_401_URLS.includes(err.config?.url) &&
      window.location.pathname !== "/login"
    ) {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  },
);

const authBaseQuery =
  () =>
  async ({ responseType, url, method, body, params, ...requestOpts }) => {
    try {
      const isBlobRequest = url.includes("/user_activity/download");
      const result = await axiosInstance({
        url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
        responseType: isBlobRequest ? "blob" : "json",
      });
      return { data: result?.data };
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };

export default authBaseQuery();
